import { createContext, useContext } from 'react';

import { TSidebarContextType } from './types.ts';

export const SidebarContext = createContext<TSidebarContextType | null>(null);

export function useSidebarContext(): TSidebarContextType {
    const context = useContext(SidebarContext);
    if (!context) throw new Error('SidebarProvider is missing');

    return context;
}
